import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  FilterRow,
  FormItem,
  HeaderFilter,
  LoadPanel,
  Lookup,
  MasterDetail,
  Form,
  Export,
  Scrolling,
  StateStoring,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { SimpleItem, RequiredRule } from "devextreme-react/form";
import React, { useState, useEffect, useRef } from "react";
import notify from "devextreme/ui/notify";

import { EQPT_TYPE } from "./data";
import QRItem from "./QRItem";

import MasterDetailView from "./MasterDetailView";

import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import Header from "../common/Header";

// import logoImg from "./beccoCRO.png";

export default function EquipmentManagement() {
  const [dataSource, setDataSource] = useState(null);
  // const [type, setType] = useState(null);
  const dataGridRef = useRef(null);

  useEffect(() => {
    document.title = "장비관리";

    setDataSource(
      new CustomStore({
        key: "codeNo",
        load: async () => {
          try {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt`
            );

            return result.data;
          } catch (error) {
            return console.log(error);
          }
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt`,
            values
          );
        },
        update: async (key, values) => {
          const typeNSEQ = getTypeNSEQ(key);

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt/${typeNSEQ.type}/${typeNSEQ.SEQ}`,
            values
          );
        },
        remove: async (key) => {
          const typeNSEQ = getTypeNSEQ(key);

          const result = await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt/${typeNSEQ.type}/${typeNSEQ.SEQ}`
          );

          if (result.data.msg) {
            notify(
              {
                message: `${result.data.msg}`,
                width: 450,
              },
              "error",
              2000
            );
          }
        },
      })
    );
  }, []);

  const getTypeNSEQ = (key) => {
    const sType = key.substring(0, 5);

    return {
      type:
        sType == "BCENO"
          ? 1
          : sType == "BCEMO"
          ? 2
          : sType == "BCEOT"
          ? 9
          : null,
      SEQ: parseInt(key.substring(5)) + "",
    };
  };

  const onEditorPreparing = (e) => {
    if (e.dataField == "type" && e.parentType == "dataRow") {
      e.editorOptions.disabled = !e.row.isNewRow;
    }
  };

  const renderGridCell = (data) => {
    const { codeNo, type, SEQ } = data.data;

    return <QRItem codeNo={codeNo} type={type} SEQ={SEQ} />;
  };

  const renderDetail = (props) => {
    const { type, SEQ } = props.data;

    return <MasterDetailView type={type} SEQ={SEQ} />;
  };

  const customizeItem = (item) => {
    if (item) {
      if (
        item.dataField === "cpu" ||
        item.dataField === "memory" ||
        item.dataField === "stgeCap"
      ) {
        let gridInstance = dataGridRef.current.instance;
        let editRowKey = gridInstance.option("editing.editRowKey");
        let index = gridInstance.getRowIndexByKey(editRowKey);
        index = index === -1 ? 0 : index;

        // let isVisible = gridInstance.cellValue(index, "AddressRequired");
        // item.visible = isVisible;
        if (gridInstance.cellValue(index, "type") == "1") {
          item.visible = true;
        }
      } else if (item.dataField === "inch") {
        let gridInstance = dataGridRef.current.instance;
        let editRowKey = gridInstance.option("editing.editRowKey");
        let index = gridInstance.getRowIndexByKey(editRowKey);
        index = index === -1 ? 0 : index;

        // let isVisible = gridInstance.cellValue(index, "AddressRequired");
        // item.visible = isVisible;
        if (gridInstance.cellValue(index, "type") == "2") {
          item.visible = true;
        }
      }
    }
  };

  const setCellValue = (newData, value) => {
    newData.type = value;
  };

  const onContentReady = (e) => {
    if (!e.component.getSelectedRowKeys().length) {
      e.component.selectRowsByIndexes(0);
    }
  };

  const onSelectionChanged = (e) => {
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
  };

  const onExporting = (e) => {
    e.component.beginUpdate();
    e.component.columnOption("cpu", "visible", true);
    e.component.columnOption("memory", "visible", true);
    e.component.columnOption("stgeCap", "visible", true);
    e.component.columnOption("inch", "visible", true);

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("장비 관리");

    let masterRows = [];
    let eqptArrData = null;

    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/eqptArr`)
      .then((result) => {
        eqptArrData = result.data;

        exportDataGrid({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
          customizeCell: function ({ gridCell, excelCell }) {
            if (
              gridCell.column.dataField === "codeNo" &&
              gridCell.rowType === "data"
            ) {
              masterRows.push({
                rowIndex: excelCell.fullAddress.row + 1,
                data: gridCell.data,
                arrData: eqptArrData.filter(
                  (eqptArr) =>
                    eqptArr.type == gridCell.data.type &&
                    eqptArr.SEQ == gridCell.data.SEQ
                ),
              });
            }
          },
        })
          .then((cellRange) => {
            const borderStyle = { style: "thin", color: { argb: "FF7E7E7E" } };
            let offset = 0;

            const insertRow = (index, offset, outlineLevel) => {
              const currentIndex = index + offset;
              const row = worksheet.insertRow(currentIndex, [], "n");

              for (var j = worksheet.rowCount + 1; j > currentIndex; j--) {
                worksheet.getRow(j).outlineLevel = worksheet.getRow(
                  j - 1
                ).outlineLevel;
              }

              row.outlineLevel = outlineLevel;

              return row;
            };

            for (var i = 0; i < masterRows.length; i++) {
              if (masterRows[i].arrData.length > 0) {
                let row = null;
                // row = insertRow(masterRows[i].rowIndex + i, offset++, 2);
                let columnIndex = cellRange.from.column + 1;
                // row.height = 40;

                // let eqptData = masterRows[i].data;

                // // let employeeData = employees.find(
                // //   (item) => item.ID === masterRows[i].data.ID
                // // );
                // // console.log(employeeData);
                // Object.assign(row.getCell(columnIndex), {
                //   // value: getEmployeeCaption(employeeData),
                //   value: eqptData.codeNo,
                //   fill: {
                //     type: "pattern",
                //     pattern: "solid",
                //     fgColor: { argb: "BEDFE6" },
                //   },
                // });
                // worksheet.mergeCells(row.number, columnIndex, row.number, 7);

                const columns1 = [
                  {
                    field: "name",
                    name: "임직원명",
                  },
                  {
                    field: "asgmtDate",
                    name: "배치일자",
                  },
                  {
                    field: "unasgmtDate",
                    name: "회수일자",
                  },
                ];
                const columns2 = [
                  {
                    field: "loc",
                    name: "위치",
                  },
                  {
                    field: "asgmtDate",
                    name: "배치일자",
                  },
                  {
                    field: "unasgmtDate",
                    name: "회수일자",
                  },
                ];

                row = insertRow(masterRows[i].rowIndex + i, offset++, 2);

                if (masterRows[i].data.type == "1") {
                  columns1.forEach((column, currentColumnIndex) => {
                    Object.assign(
                      row.getCell(columnIndex + currentColumnIndex),
                      {
                        value: column.name,
                        fill: {
                          type: "pattern",
                          pattern: "solid",
                          fgColor: { argb: "BEDFE6" },
                        },
                        font: { bold: true },
                        // border: {
                        //   bottom: borderStyle,
                        //   left: borderStyle,
                        //   right: borderStyle,
                        //   top: borderStyle,
                        // },
                      }
                    );
                  });

                  // eslint-disable-next-line no-loop-func
                  masterRows[i].arrData.forEach((arr) => {
                    row = insertRow(masterRows[i].rowIndex + i, offset++, 2);

                    columns1.forEach((column, currentColumnIndex) => {
                      Object.assign(
                        row.getCell(columnIndex + currentColumnIndex),
                        {
                          value: arr[column.field],
                          fill: {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "BEDFE6" },
                          },
                          // border: {
                          //   bottom: borderStyle,
                          //   left: borderStyle,
                          //   right: borderStyle,
                          //   top: borderStyle,
                          // },
                        }
                      );
                    });
                  });
                } else if (masterRows[i].data.type == "2") {
                  columns2.forEach((column, currentColumnIndex) => {
                    Object.assign(
                      row.getCell(columnIndex + currentColumnIndex),
                      {
                        value: column.name,
                        fill: {
                          type: "pattern",
                          pattern: "solid",
                          fgColor: { argb: "BEDFE6" },
                        },
                        font: { bold: true },
                        // border: {
                        //   bottom: borderStyle,
                        //   left: borderStyle,
                        //   right: borderStyle,
                        //   top: borderStyle,
                        // },
                      }
                    );
                  });

                  // eslint-disable-next-line no-loop-func
                  masterRows[i].arrData.forEach((arr) => {
                    row = insertRow(masterRows[i].rowIndex + i, offset++, 2);

                    columns2.forEach((column, currentColumnIndex) => {
                      Object.assign(
                        row.getCell(columnIndex + currentColumnIndex),
                        {
                          value: arr[column.field],
                          fill: {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "BEDFE6" },
                          },
                          // border: {
                          //   bottom: borderStyle,
                          //   left: borderStyle,
                          //   right: borderStyle,
                          //   top: borderStyle,
                          // },
                        }
                      );
                    });
                  });
                }
              }

              offset--;
            }
          })
          .then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
              saveAs(
                new Blob([buffer], {
                  type: "application/octet-stream",
                }),
                "장비관리.xlsx"
              );

              e.component.columnOption("cpu", "visible", false);
              e.component.columnOption("memory", "visible", false);
              e.component.columnOption("stgeCap", "visible", false);
              e.component.columnOption("inch", "visible", false);
              e.component.endUpdate();
            });
          });
      });

    e.cancel = true;
  };

  // const onExported = (e) => {
  //   e.component.columnOption("cpu", "visible", false);
  //   e.component.columnOption("memory", "visible", false);
  //   e.component.columnOption("stgeCap", "visible", false);
  //   e.component.columnOption("inch", "visible", false);
  //   e.component.endUpdate();
  // };

  return (
    <React.Fragment>
      {/* <h1
        style={{
          color: "#1B4452",
          marginBlockStart: "0.67em",
          marginBlockEnd: "0.67em",
          marginInlineStart: "0px",
          marginInlineEnd: "0px",
        }}
      >
        장비관리
      </h1> */}
      <Header title="EQUIPMENT MANAGEMENT" menuDataSource={null} />
      <DataGrid
        id="EqptMgmtGrid"
        ref={dataGridRef}
        dataSource={dataSource}
        keyExpr="codeNo"
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        onEditorPreparing={onEditorPreparing}
        onExporting={onExporting}
        // onExported={onExported}
        // onContentReady={onContentReady}
        // onSelectionChanged={onSelectionChanged}
      >
        <LoadPanel enabled={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <Export enabled={true} />

        {/* <Scrolling mode={"virtual"} showScrollbar="always" /> */}
        <Scrolling
          rowRenderingMode="virtual"
          showScrollbar={"always"}
        ></Scrolling>
        <Paging defaultPageSize={13} />
        <Pager
          visible={true}
          allowedPageSizes={[10, 20, "all"]}
          displayMode={"full"}
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true}
        />

        {/* <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"EquipmentManagement"}
        /> */}

        <Editing
          mode="form"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}
        >
          <Form
            labelMode={"outside"}
            showColonAfterLabel={false}
            labelLocation={"top"}
            minColWidth={300}
            colCount={2}
            colCountByScreen={{
              sm: 2,
              md: 4,
            }}
            screenByWidth={(width) => {
              return width < 720 ? "sm" : "md";
            }}
            validationGroup="basicInfo"
            customizeItem={customizeItem}
          >
            <SimpleItem dataField="type">
              <RequiredRule message="* 유형을 선택해주세요." />
            </SimpleItem>
            <SimpleItem
              dataField="yrMthOfMfg"
              editorType="dxDateBox"
              editorOptions={{
                max: new Date(),
              }}
            >
              <RequiredRule message="* 제조년월을 입력해주세요." />
            </SimpleItem>
            <SimpleItem dataField="mfgCo">
              <RequiredRule message="* 제조사를 입력해주세요." />
            </SimpleItem>
            <SimpleItem dataField="mName">
              <RequiredRule message="* 모델명을 입력해주세요." />
            </SimpleItem>
            <SimpleItem dataField="cpu" visible={false}>
              <RequiredRule message="* CPU 사양을 입력해주세요." />
            </SimpleItem>
            <SimpleItem dataField="memory" visible={false}>
              <RequiredRule message="* 메모리 사양을 입력해주세요." />
            </SimpleItem>
            <SimpleItem dataField="stgeCap" visible={false}>
              <RequiredRule message="* 저장용량을 입력해주세요." />
            </SimpleItem>
            <SimpleItem
              dataField="inch"
              visible={false}
              editorType="dxNumberBox"
            >
              <RequiredRule message="* 모니터 인치 사이즈를 입력해주세요." />
            </SimpleItem>
          </Form>
        </Editing>

        {/* <Selection mode="single" /> */}

        <Column dataField="codeNo" caption="Code No." dataType="string">
          <FormItem visible={false} />
        </Column>
        <Column
          dataField="type"
          caption="유형"
          dataType="string"
          setCellValue={setCellValue}
        >
          <Lookup dataSource={EQPT_TYPE} displayExpr="name" valueExpr="id" />
        </Column>
        <Column
          dataField="yrMthOfMfg"
          caption="제조년월"
          dataType="date"
          format="yyyy-MM-dd"
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-dd",
          }}
        />
        <Column dataField="mfgCo" caption="제조사" dataType="string" />
        <Column dataField="mName" caption="모델명" dataType="string" />
        <Column
          caption="QR"
          width={80}
          alignment="center"
          cellRender={renderGridCell}
          allowExporting={false}
        >
          <FormItem visible={false} />
        </Column>
        <Column
          dataField="cpu"
          caption="CPU"
          dataType="string"
          visible={false}
          allowExporting={true}
        />
        <Column
          dataField="memory"
          caption="Memory"
          dataType="string"
          visible={false}
        />
        <Column
          dataField="stgeCap"
          caption="Storage Capacity"
          dataType="string"
          visible={false}
        />
        <Column
          dataField="inch"
          caption="Inch"
          dataType="number"
          visible={false}
        />

        <MasterDetail enabled={true} render={renderDetail} />
      </DataGrid>
    </React.Fragment>
  );
}
